
import { BasicController, EnvGlobalsHandler } from "@goodgamestudios/core";
import { BasicModel } from "@goodgamestudios/core";
import { IEnvironmentGlobals } from "@goodgamestudios/core";
import { SFConstants } from "../constants/SFConstants";
import { Poker2OnTableEvent } from "../event/Poker2OnTableEvent";
import { C2STutorialStepVO } from "./commandVO/C2STutorialStepVO";

import { BasicTutorialController } from "../../basic/controller/BasicTutorialController";
import { AnimatedDisplayObject } from "../../basic/graphics/animation/AnimatedDisplayObject";
import { AnimatedMovieClip } from "../../basic/graphics/animation/AnimatedMovieClip";

import Container = createjs.Container;
import MovieClip = createjs.MovieClip;

export class Poker2TutorialController extends BasicTutorialController {
    private static tutorialControllerInstance: Poker2TutorialController;

    public static TUT_STEP2_TABLESELECTION: string = "tut_step2_tableSelection";
    public static TUT_STEP3_PLAYBUTTON: string = "tut_step3_playButton";
    public static TUT_STEP4_FREESEAT: string = "tut_step4_freeSeat";
    public static TUT_STEP5_BUYIN: string = "tut_step5_buyIn";
    public static TUT_STEP6_DEALERBUTTON: string = "tut_step6_dealerButton";
    public static TUT_STEP7_SMALLBLIND: string = "tut_step7_smallBlind";
    public static TUT_STEP8_BIGBLIND: string = "tut_step8_bigBlind";
    public static TUT_STEP9_HOLECARDS: string = "tut_step9_holeCards";
    public static TUT_STEP10_ALINAFOLD: string = "tut_step10_alinaFold";
    public static TUT_STEP11_ACTIONHELP: string = "tut_step11_actionHelp";
    public static TUT_STEP12_ACTIONHELP2: string = "tut_step12_actionHelp2";
    public static TUT_STEP13_PLAYERACTIONCALL: string = "tut_step13_playerActionCall";
    public static TUT_STEP14_TIMOCALL: string = "tut_step14_timoCall";
    public static TUT_STEP15_OLIVERCHECK: string = "tut_step15_oliverCheck";
    public static TUT_STEP16_POT: string = "tut_step16_pot";
    public static TUT_STEP17_FLOP: string = "tut_step17_flop";
    public static TUT_STEP18_TIMOCHECK: string = "tut_step18_timoCheck";
    public static TUT_STEP19_OLIVERCHECK: string = "tut_step19_oliverCheck";
    public static TUT_STEP20_HANDSTRENGTH: string = "tut_step20_handStrength";
    public static TUT_STEP21_HANDSTRENGTH2: string = "tut_step21_handStrength2";
    public static TUT_STEP22_PLAYERACTIONCHECK: string = "tut_step22_playerActionCheck";
    public static TUT_STEP23_TURN: string = "tut_step23_turn";
    public static TUT_STEP24_TIMORAISE: string = "tut_step24_timoRaise";
    public static TUT_STEP25_OLIVERFOLD: string = "tut_step25_oliverFold";
    public static TUT_STEP26_PLAYERACTIONCALL: string = "tut_step26_playerActionCall";
    public static TUT_STEP27_RIVER: string = "tut_step27_river";
    public static TUT_STEP28_TIMOCHECK: string = "tut_step28_timoCheck";
    public static TUT_STEP29_PLAYERACTIONRAISE: string = "tut_step29_playerActionRaise";
    public static TUT_STEP30_TIMORERAISE: string = "tut_step30_timoReraise";
    public static TUT_STEP31_PLAYERACTIONALLIN: string = "tut_step31_playerActionAllin";
    public static TUT_STEP32_TIMOALLIN: string = "tut_step32_timoAllin";
    public static TUT_STEP33_SHOWCARDS: string = "tut_step33_showCards";
    public static TUT_STEP34_VICTORY: string = "tut_step34_victory";
    public static TUT_STEP35_XPBAR: string = "tut_step35_xpBar";
    public static TUT_STEP36_LEVELUP: string = "tut_step36_levelUp";
    public static TUT_STEP37_STANDUP: string = "tut_step37_standUp";
    public static TUT_STEP38_LEAVETABLE: string = "tut_step38_leaveTable";
    public static TUT_STEP39_CONGRATULATION_COPY: string = "tut_step39_congratulation_copy";
    //		public static const TUT_STEP39_CONGRATULATION_TITLE:String 	= "tut_step39_congratulation_title";
    public static TUT_STEP40_REWARD: string = "tut_step40_reward";

    public aimDO_tutotialArrow: AnimatedDisplayObject;

    public static trackedSteps: any[] = [];

    constructor() {
        super();
        this.stateOrder = [
            BasicTutorialController.TUT_STATE_WELCOME,
            "tut_step2_tableSelection",
            "tut_step3_playButton",
            "tut_step4_freeSeat",
            "tut_step5_buyIn",
            "tut_step6_dealerButton",
            "tut_step7_smallBlind",
            "tut_step8_bigBlind",
            "tut_step9_holeCards",
            "tut_step10_alinaFold",
            "tut_step11_actionHelp",
            "tut_step12_actionHelp2",
            "tut_step13_playerActionCall",
            "tut_step14_timoCall",
            "tut_step15_oliverCheck",
            "tut_step16_pot",
            "tut_step17_flop",
            "tut_step18_timoCheck",
            "tut_step19_oliverCheck",
            "tut_step20_handStrength",
            "tut_step21_handStrength2",
            "tut_step22_playerActionCheck",
            "tut_step23_turn",
            "tut_step24_timoRaise",
            "tut_step25_oliverFold",
            "tut_step26_playerActionCall",
            "tut_step27_river",
            "tut_step28_timoCheck",
            "tut_step29_playerActionRaise",
            "tut_step30_timoReraise",
            "tut_step31_playerActionAllin",
            "tut_step32_timoAllin",
            "tut_step33_showCards",
            "tut_step34_victory",
            "tut_step35_xpBar",
            "tut_step36_levelUp",
            "tut_step37_standUp",
            "tut_step38_leaveTable",
            "tut_step39_congratulation_copy",
            "tut_step40_reward",
            BasicTutorialController.TUT_STATE_COMPLETED
        ];
    }

    /**
     *	startet das Tutorial
     *
     *  @param tutorialArrow:MovieClip
     */
    public startTutorial(tutorialArrow: MovieClip): void {
        BasicModel.smartfoxClient.sendMessage("tts", []);
        BasicController.getInstance().soundController.muteAll();
        this.layoutManager.addTutorialPanel();
        tutorialArrow.mouseChildren = false;
        tutorialArrow.mouseEnabled = false;
        super.startTutorial(tutorialArrow);
    }

    public set tutorialState(state: string) {
        switch (state) {
            case BasicTutorialController.TUT_STATE_COMPLETED:
                this.endTutorial();
                break;
        }
        this._currentStateStep = this.stateOrder.indexOf(state);
        this._tutorialState = state;

        // track every step only once
        if (Poker2TutorialController.trackedSteps[this._tutorialState]) {
            // current step has been tracked already, do nothing
            return;
        }

        // store tracked step
        Poker2TutorialController.trackedSteps[this._tutorialState] = this._tutorialState;

        //			BasicController.getInstance().dispatchEvent(new Poker2TutorialEvent("tutorialstatechange"));
    }

    public nextStep(): void {
        BasicModel.smartfoxClient.sendCommandVO(new C2STutorialStepVO(1));
        this.removeArrow();
        this._currentStateStep++;
        this.tutorialState = this.stateOrder[this._currentStateStep];
    }

    protected initArrow(tutorialArrow: MovieClip): void {
        super.initArrow(tutorialArrow);
        this.aimDO_tutotialArrow = new AnimatedMovieClip(-1, 1, "ta");
        this.aimDO_tutotialArrow.processAnimation(tutorialArrow, null, false);
        this.aimDO_tutotialArrow.setFrameRate(24);
        this.aimDO_tutotialArrow.play();
        this.aimDO_tutotialArrow.disp.mouseChildren = false;
    }

    public removeArrow(): void {
        if (!this.mc_tutotialArrow)
            return;
        this.mc_tutotialArrow.scaleX = this.mc_tutotialArrow.scaleY = 1;
        this.mc_tutotialArrow.x = 0;
        this.mc_tutotialArrow.y = 0;
        if (this.mc_tutotialArrow.parent)
            if (this.mc_tutotialArrow.parent.contains(this.mc_tutotialArrow))
                this.mc_tutotialArrow.parent.removeChild(this.mc_tutotialArrow);
    }

    /*
    override public function addTutorialArrowAt(item:DisplayObjectContainer, mirror:Boolean = true):void
    {
        removeArrow();
        item.addChild(tutorialArrow);
        if(mirror)
            mirrorArrow();
    }
    */

    public addTutorialArrowAndFlip(item: Container, mirror: boolean = true, flip: boolean = false): void {
        this.removeArrow();
        item.addChild(this.tutorialArrow);
        if (mirror)
            this.mirrorArrow();
        if (flip)
            this.flipArrow();
    }

    public endTutorial(): void {
        BasicController.getInstance().soundController.unMuteAll();
        this.removeArrow();
        // removeSpotlight();
        this.aimDO_tutotialArrow = null;
        this.layoutManager.removeTutorialPanel();
        super.endTutorial();
    }

    public cancelTutorial(): void {
        BasicController.getInstance().soundController.unMuteAll();
        this.removeArrow();
        // removeSpotlight();
        this.aimDO_tutotialArrow = null;
        TutorialHitAreaHelper.removeTutorialHitArea();
        this.layoutManager.removeTutorialPanel();
        if (this.layoutManager.currentState != 11) {
            this.layoutManager.state = 11;
            BasicController.getInstance().dispatchEvent(new Poker2OnTableEvent("standUp"));
        }

        super.cancelTutorial();
        BasicModel.smartfoxClient.sendMessage("tcl", []);
    }

    public static getInstance(): Poker2TutorialController {
        if (!Poker2TutorialController.tutorialControllerInstance)
            Poker2TutorialController.tutorialControllerInstance = new Poker2TutorialController();
        return Poker2TutorialController.tutorialControllerInstance;
    }

    public prevStep(): void {
        BasicModel.smartfoxClient.sendCommandVO(new C2STutorialStepVO(0));
        this.removeArrow();
        this._currentStateStep--;
        this.tutorialState = this.stateOrder[this._currentStateStep];
    }

    public get mc_tutotialArrow(): Container {
        if (this.aimDO_tutotialArrow && this.aimDO_tutotialArrow.disp)
            return this.aimDO_tutotialArrow.disp;
        else
            return null;
    }

    private get layoutManager(): Poker2LayoutManager {
        return Poker2LayoutManager.getInstance();
    }

    protected get env(): IEnvironmentGlobals {
        return EnvGlobalsHandler.globals;
    }

    /**
     * TRANSPILER GENERATED FUNCTION: If a setter is defined, the getter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
     */
    public get tutorialState()/*:String*/ {
        return Object.getOwnPropertyDescriptor(BasicTutorialController.prototype, "tutorialState").get.call(this);
    }

    /**
     * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
     */
    protected set env(value/*:IEnvironmentGlobals*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(BasicTutorialController.prototype, "env").set.call(this, value);
    }
}

import { Poker2LayoutManager } from "../view/Poker2LayoutManager";
import {TutorialHitAreaHelper} from "../view/panels/tutorial/TutorialHitAreaHelper";
